import { combineReducers } from 'redux';

import {ACTION} from './constants';

let initialState={
    offices:{}
};

export default function ContactUsReducer(state = initialState, action) {
    switch (action.type) {

        case ACTION.GET_CONTACT_US_CONTENT :
            return {...state, getInTouch:action.data, pageMeta: action.data};

        case ACTION.GET_CONTACT_US_RELATIONSHIP_OFFICER_CONTENT :
            return {...state, relationshipOfficer:action.data, pageMeta: action.data};

        case ACTION.GET_STAKEHOLDER_INFORMATION_HELPDESK :
            return {...state, stakeHolderInformation:action.data, pageMeta: action.data};
        
        case ACTION.GET_CONTACT_US_VISIT_US_CONTENT :
            return {...state, visitUs:action.data, pageMeta: action.data};

        case ACTION.GET_CHIEF_INFORMATION_CONTENT :
            return {...state, chiefInformation:action.data, pageMeta: action.data};

        case ACTION.GET_CONTACT_US_OFFICES_LIST_FILTER :
            return {...state, offices:{...state.offices, filterList:action.data}};

        case ACTION.GET_CONTACT_US_OFFICES_LIST :
            return {...state, offices:{...state.offices, officesList:action.data}};

        case ACTION.office_state_city :
            return {...state , office:action.data, pageMeta: action.data};


        default:
            return state;
    }
}
